import { PublicProfilePathSchema } from '@milestone-portal/schema/path.schema';
import { createFileRoute } from '@tanstack/react-router';

import { PublicProfileSkeleton } from './-components/pending/PublicProfileSkeleton';
import { PublicProfile } from './-components/PublicProfile';
import { PublicProfileContext } from './-logic/PublicProfileContext';
import { usePublicProfile } from './-logic/usePublicProfile';

export const Route = createFileRoute('/profile/public/$userSlug')({
  component: PublicProfilePage,
  params: {
    parse: PublicProfilePathSchema.parse,
  },
  pendingComponent: PublicProfileSkeleton,
});

function PublicProfilePage() {
  return (
    <PublicProfileContext.Provider value={usePublicProfile()}>
      <PublicProfile />
    </PublicProfileContext.Provider>
  );
}
